import { noargs } from './bits'
import { get, keys, negate, partial, isArray, isObjectLike } from 'lodash-es'

import StrictObj from './strict-obj'
import debugFields from './debug-fields'

const alphabeticalRE = /^\d+$/
const alphabeticalKeys = (v) => keys(v).filter(isAlphabeticalKey)
const isAlphabeticalKey = (v) => !alphabeticalRE.test(v)
const hasAlphabeticalKeys = (v) => isObjectLike(v) && (!isArray(v) || alphabeticalKeys(v).length !== 0)

import { defineHiddenGetter } from './define-getter'

const MARKER = '__attachGettersMarker__'
const NEGATE = 'negate'
const GETTERS = 'getters'
const TERMINATE = 'terminate'

export default function attachGetters(rootObj, attachKey = GETTERS) {
  defineHiddenGetter({
    obj: rootObj,
    key: attachKey,
    get: make
  })

  return rootObj

  function make() {
    const getters = makeGetters(rootObj)
    getters[NEGATE] = makeNegates(rootObj)
    return getters
  }

  function makeGetters(currObj, rootObj = currObj, basePath = '') {
    const currKeys = alphabeticalKeys(currObj)
    const currGetters = StrictObj({})

    currKeys.forEach((key) => {
      const subObj = currObj[key]
      const subPath = basePath + `["${key}"]`
      if (hasAlphabeticalKeys(subObj)) {
        defineHiddenGetter({
          obj: currGetters,
          key,
          get: partial(makeGetters, subObj, rootObj, subPath)
        })
      } else {
        currGetters[key] = noargs(partial(smartGet, rootObj, subPath))
        currGetters[key][TERMINATE] = currGetters[key]
        debugFields(currGetters[key], {
          _subPath: subPath,
          _rootObj: rootObj
        })
      }
    })

    currGetters[MARKER] = true
    currGetters[TERMINATE] = noargs(partial(smartGet, rootObj, basePath))
    debugFields(currGetters, {
      _rootObj: rootObj,
      _basePath: basePath
    })

    return currGetters
  }

  function makeNegates(currObj, rootObj = currObj, basePath = '') {
    const currKeys = alphabeticalKeys(currObj)
    const currNegates = StrictObj({})

    currKeys.forEach((key) => {
      const subObj = currObj[key]
      const subPath = basePath + `["${key}"]`
      if (hasAlphabeticalKeys(subObj)) {
        defineHiddenGetter({
          obj: currNegates,
          key,
          get: partial(makeNegates, subObj, rootObj, subPath)
        })
      } else {
        currNegates[key] = noargs(negate(partial(smartGet, rootObj, subPath)))
        currNegates[key][TERMINATE] = currNegates[key]
        debugFields(currNegates[key], {
          _subPath: subPath,
          _rootObj: rootObj
        })
      }
    })

    currNegates[MARKER] = true
    currNegates[TERMINATE] = noargs(negate(partial(smartGet, rootObj, basePath)))
    debugFields(currNegates, {
      _rootObj: rootObj,
      _basePath: basePath
    })

    return currNegates
  }
}

function smartGet(rootObj, subPath) {
  return subPath === '' ? rootObj : get(rootObj, subPath)
}
